import { useSettings } from '@/react/portainer/settings/queries';

export function useEdgeComputeConfigured() {
  return useSettings(
    (settings) =>
      !!(
        settings.EnableEdgeComputeFeatures &&
        settings.EdgePortainerUrl &&
        settings.Edge.TunnelServerAddress
      )
  );
}
